module.exports = __webpack_public_path__ + "img/DE02740.f4685f4b.png";